import {Observable, Subscription} from 'rxjs';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {ConfigurationModel, ConfigurationService} from './configuration-service';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {appRoutes} from './app.module';

@Injectable()
export class ConfigurationGuardService implements CanActivate {

  constructor(
    private configuration: ConfigurationService) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise<boolean>((resolve: any) => {
      const cb = (props: ConfigurationModel) => {
        const blockAccess = route.routeConfig?.data?.blockAccess || ((p: any) => false);
        if (blockAccess(props)) {
          // replace the config with that of PageNotFoundComponent
          route.routeConfig.component = PageNotFoundComponent;
          route.routeConfig.data = appRoutes.find((r) => r.path === '**').data;
        }
        resolve(true);
      };
      if (this.configuration.isReady) {
        cb(this.configuration.getProperties());
      } else {
        const sub: Subscription = this.configuration.whenReady().subscribe((v) => {
          if (v === true) {
            sub.unsubscribe();
            cb(this.configuration.getProperties());
          }
        });
      }
    });
  }
}
